import { apiConfig } from '../api-config';

export default async function (cdTerritory: string) {
  return apiConfig
    .get(`api/Penalty/GetPenalty?cdTerritory=${cdTerritory}`)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
}
